<template>
    <div class="root" v-loading="loading">

        
      <topmenu></topmenu>




        <!-- content -->

        <div class="container2 theme-showcase">

            <div style="margin-top: 20px; display: flex; align-items: center;">
                <div>
                    <el-page-header @back="goBack" title="Back">
                    </el-page-header>
                </div>
                <div>
                    <el-button type="primary" icon="el-icon-plus" size="medium" @click="add">Add</el-button>
                </div>
                <div style="margin-left: 12px;">
                    <el-select v-model="eventId" size="medium" placeholder="Select" @change="eventChange">
                        <el-option v-for="item in eventList" :key="item.id" :label="item.eventName" :value="item.id">
                        </el-option>
                    </el-select>
                </div>

            </div>

            <div style="margin: 16px 0;">
                <el-table :data="list" border style="width: 100%" fit ref="table">
                    <el-table-column prop="index" label="No" width="60" fixed="left">
                    </el-table-column>
                    <el-table-column prop="FieldName" label="Field Name" min-width="100" width="220">
                    </el-table-column>
                    <el-table-column prop="FieldCode" label="Field Code" min-width="100">
                    </el-table-column>
                    <el-table-column prop="BackendFieldName" label="Backend Field Name" min-width="170">
                    </el-table-column>
                    <el-table-column prop="FieldDesc" label="Field Desc" min-width="100">
                    </el-table-column>
                    <el-table-column prop="PreDefinedFieldID" label="PreDefined FieldType" min-width="180">
                    </el-table-column>

                    
                    <el-table-column prop="FieldTypeID" label="Field Type" min-width="100">
                    </el-table-column>
                    <el-table-column prop="IsCompulsoryStr" label="Compulsory" min-width="110">
                    </el-table-column>
                    <el-table-column prop="RequiredFieldValidatorErrorMessage" label="Required Field Validator Message" min-width="260">
                    </el-table-column>
                    <el-table-column prop="IsReadOnlyStr" label="ReadOnly" min-width="100">
                    </el-table-column>
                    <el-table-column prop="LookupValues" label="Options" min-width="80">
                    </el-table-column>
                    <el-table-column prop="SortLookupValues" label="Sort Options" min-width="120">
                    </el-table-column>
                    <el-table-column prop="PhoneCodeModelStr" label="Country Code Model" min-width="180">
                    </el-table-column>
                    
                    <el-table-column prop="IsLimitedInListStr" label="Limited In Options" min-width="150">
                    </el-table-column>
                    <el-table-column prop="MaxLength" label="Max Length" min-width="120">
                    </el-table-column>
                    <el-table-column prop="Hint" label="Hint" min-width="80">
                    </el-table-column>
                    <el-table-column prop="Note" label="Note" min-width="80">
                    </el-table-column>
                    <el-table-column prop="RegularExpressionValidatorValidationExpression" label="Regular Expression Validator" min-width="240">
                    </el-table-column>
                    <el-table-column prop="RegularExpressionValidatorErrorMessage" label="Regular Expression Validator Error Message" min-width="340">
                    </el-table-column>
                    <el-table-column prop="SelfRegSkipStr" label="Self Reg Skip" min-width="140">
                    </el-table-column>
                    <el-table-column prop="IsEdmEmailStr" label="IsEdmEmail" min-width="100">
                    </el-table-column>
                    <el-table-column prop="TextMode" label="TextMode" min-width="100">
                    </el-table-column>
                    <el-table-column prop="IsAdminCompulsoryStr" label="Admin Compulsory" min-width="160">
                    </el-table-column>
                    <el-table-column prop="MinValue" label="MinValue" min-width="100">
                    </el-table-column>
                    <el-table-column prop="MaxValue" label="MaxValue" min-width="100">
                    </el-table-column>
                    <el-table-column prop="StaticHtml" label="Static Html" min-width="100" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="GroupHeader" label="Group Header" min-width="120">
                    </el-table-column>
                    <el-table-column prop="GroupFooter" label="Group Footer" min-width="120">
                    </el-table-column>
                    <el-table-column prop="CustomTextPompt" label="Custom Text Pompt" min-width="160">
                    </el-table-column>
                    <el-table-column prop="ComboBoxOthersValue" label="Select Others Value" min-width="220">
                    </el-table-column>
                    <el-table-column prop="TitleCapitalStr" label="Title Capital" min-width="150">
                    </el-table-column>
                    <el-table-column prop="UppercaseStr" label="Uppercase" min-width="100">
                    </el-table-column>
                    <el-table-column prop="Layout" label="Options Layout" min-width="140">
                    </el-table-column>
                    <el-table-column prop="HideLabelStr" label="Hide Label" min-width="120">
                    </el-table-column>
                    <el-table-column prop="DefaultValue" label="Default Value" min-width="130">
                    </el-table-column>
                    <el-table-column prop="DisplaySameLineAfterPreFdStr" label="Display Same Line" min-width="200">
                    </el-table-column>
                    <el-table-column prop="VisibleDependFieldCode" label="Visible Depend Field" min-width="200">
                    </el-table-column>
                    <el-table-column prop="VisibleDependFieldValue" label="Visible Depend Field Value" min-width="220">
                    </el-table-column>
                    <el-table-column prop="CompulsoryDependFieldCode" label="Compulsory Depend Field" min-width="240">
                    </el-table-column>
                    <el-table-column prop="CompulsoryDependFieldValue" label="Compulsory Depend Field Value" min-width="250">
                    </el-table-column>
                    <el-table-column prop="CompareFieldCode" label="Compare Field" min-width="140">
                    </el-table-column>
                    <el-table-column prop="CompareDiff" label="Compare Diff" min-width="140">
                    </el-table-column>
                    <el-table-column prop="CompareSign" label="Compare Sign" min-width="140">
                    </el-table-column>
                    <el-table-column prop="CompareErrorMessage" label="Compare Error Message" min-width="200">
                    </el-table-column>


                    <el-table-column label="Edit" fixed="right" min-width="180">
                        <template slot-scope="scope">
                            <el-button type="info" icon="el-icon-top" circle @click="handleFieldUp(scope.$index, scope.row)" size="mini"></el-button>
                                <el-button type="info" icon="el-icon-bottom" circle @click="handleFieldDown(scope.$index, scope.row)" size="mini"></el-button>
                            <el-button type="primary" icon="el-icon-edit" circle @click="handleEdit(scope.$index, scope.row)" size="mini"></el-button>
                                <el-button type="danger" icon="el-icon-delete" circle @click="handleDelete(scope.$index, scope.row)" size="mini"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- <div style="margin:12px 0;">
                    <div v-if="total > 1">
                        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange"
                            :current-page.sync="currentPage" :total="total">
                        </el-pagination>
                    </div>
                </div> -->
            </div>


            <el-dialog title="Field" :visible.sync="dialogFormVisible" width="1150px" custom-class="fieldEditDialog">
                <div style="max-height: calc(100vh - 270px); overflow-y: auto;">
                <el-form label-width="180px">
                    <el-form-item label="Field Name:" required :error="nameErr">
                        <el-input v-model="FieldName" @change="nameChange"></el-input>
                    </el-form-item>

                    <el-form-item label="Field Code:">
                        <el-input v-model="FieldCode"></el-input>
                    </el-form-item>

                    <el-form-item label="Backend Field Name:">
                        <el-input v-model="BackendFieldName"></el-input>
                    </el-form-item>

                    <el-form-item label="Field Desc:">
                        <el-input v-model="FieldDesc"></el-input>
                    </el-form-item>

                    <el-form-item label="PreDefined FieldType:">
                        <el-select v-model="PreDefinedFieldID" placeholder="Select" @change="preDefinedFieldChange" clearable>
                            <el-option v-for="(item, index) in preFieldTypeList" :key="item.id" :label="item.fieldName"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item label="Field Type:" required :error="FieldTypeErr">
                        <el-select v-model="FieldTypeID" placeholder="Select" :disabled="PreDefinedFieldID!=''?true:false" >
                            <el-option v-for="(item, index) in fieldTypeList" :key="item.id" :label="item.name"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item v-if="FieldTypeID==6" label="Country Code Model:" :error="FieldTypeErr">
                        <el-select v-model="PhoneCodeModel" placeholder="Select">
                            <el-option label="Input" value="2"></el-option>
                            <el-option label="Select" value="1"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="Compulsory:" v-if="FieldTypeID!=10">
                        <el-switch v-model="IsCompulsory" ></el-switch>
                    </el-form-item>

                    <el-form-item label="Required Field Validator Message:" v-if="IsCompulsory">
                        <el-input v-model="RequiredFieldValidatorErrorMessage"></el-input>
                    </el-form-item>

                    <el-form-item label="ReadOnly:" v-if="FieldTypeID!=10">
                        <el-switch v-model="IsReadOnly" ></el-switch>
                    </el-form-item>

                    <el-form-item label="Options:" v-if="FieldTypeID==2||FieldTypeID==3||FieldTypeID==4 || FieldTypeID==9|| FieldTypeID==13">
                        <div style="border: 1px solid rgb(233, 233, 235); border-radius: 8px; padding: 16px; max-height: 400px; overflow-y: auto;">
                            <div v-for="(item, index) in LookupValuesArr" :key="index" style="display: flex;">
                                <div>{{ index+1 }}</div>
                            <div class="optionItem" >
                                <div class="optionItemTxt">
                                    <div v-if="!item.edit">
                                        {{ item.txt }}
                                    </div>
                                    <div v-else style="margin-left: -12px;">
                                        <el-input v-model="optionEditTxt" @blur="editOptionBlur(index)" placeholder="Please enter"></el-input>
                                    </div>
                                </div>
                                <div class="optionItemControl optionItemTop" @click="upOption(index)"><i class="el-icon-caret-top"></i></div>
                                <div class="optionItemControl optionItemBtm" @click="downOption(index)"><i class="el-icon-caret-bottom"></i></div>
                                <div class="optionItemControl optionItemEdit"  @click="editOption(index)">
                                    <i v-if="!item.edit" class="el-icon-edit"></i>
                                    <i v-else class="el-icon-edit-outline"></i>
                                </div>
                                <div class="optionItemControl optionItemDel" @click="delOption(index)"><i class="el-icon-delete"></i></div>
                            </div>
                        </div>
                            <div>
                                <el-button type="success" size="mini" round icon="el-icon-plus" @click="addOption">Add</el-button>
                            </div>
                        </div>
                    </el-form-item>

                    <el-form-item label="Sort Options:" v-if="FieldTypeID==2||FieldTypeID==3||FieldTypeID==4 || FieldTypeID==9|| FieldTypeID==13">
                        <el-switch v-model="SortLookupValues" ></el-switch>
                    </el-form-item>

                    <el-form-item label="Limited In Options:" v-if="FieldTypeID==2||FieldTypeID==3||FieldTypeID==4 || FieldTypeID==9|| FieldTypeID==13">
                        <el-switch v-model="IsLimitedInList" ></el-switch>
                    </el-form-item>

                    <el-form-item label="Max Length:" v-if="FieldTypeID==1||FieldTypeID==3||FieldTypeID==6 || FieldTypeID==9 || FieldTypeID==12|| FieldTypeID==13">
                        <el-input-number v-model="MaxLength" :min="0" :max="100000"></el-input-number>
                    </el-form-item>

                    <el-form-item label="Hint:" v-if="FieldTypeID!=10">
                        <el-input v-model="Hint"></el-input>
                    </el-form-item>

                    <el-form-item label="Note:" v-if="FieldTypeID!=10">
                        <el-input v-model="Note"></el-input>
                    </el-form-item>

                    

                    <el-form-item label="Regular Expression Validator:" v-if="FieldTypeID!=10">
                        <el-input v-model="RegularExpressionValidatorValidationExpression"></el-input>
                    </el-form-item>

                    <el-form-item label="Regular Expression Validator Error Message:" v-if="RegularExpressionValidatorValidationExpression!=''">
                        <el-input v-model="RegularExpressionValidatorErrorMessage"></el-input>
                    </el-form-item>

                    <el-form-item label="Self Reg Skip:" v-if="FieldTypeID!=10">
                        <el-switch v-model="SelfRegSkip" ></el-switch>
                    </el-form-item>

                    <el-form-item label="Is Edm Email:" v-if="FieldTypeID==1">
                        <el-switch v-model="IsEdmEmail" ></el-switch>
                    </el-form-item>

                    <el-form-item label="TextMode:" v-if="FieldTypeID==1">
                    <el-select v-model="TextMode" placeholder="Select" clearable>
                            <el-option label="number" value="Number"></el-option>
                            <el-option label="password" value="password"></el-option>
                            <el-option label="text" value="text"></el-option>
                            <el-option label="textarea" value="textarea"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="Admin Compulsory:" v-if="FieldTypeID!=10">
                        <el-switch v-model="IsAdminCompulsory" ></el-switch>
                    </el-form-item>

                    <el-form-item label="MinValue:" v-if="FieldTypeID==1||FieldTypeID==7||FieldTypeID==8||FieldTypeID==11||FieldTypeID==12">
                        <el-input v-model="MinValue"></el-input>
                    </el-form-item>

                    <el-form-item label="MaxValue:" v-if="FieldTypeID==1||FieldTypeID==7||FieldTypeID==8||FieldTypeID==11||FieldTypeID==12">
                        <el-input v-model="MaxValue"></el-input>
                    </el-form-item>

                    <el-form-item label="Static Html:" v-if="FieldTypeID==10">
                        <el-input v-model="StaticHtml" type="textarea"></el-input>
                    </el-form-item>

                    <el-form-item label="Group Header:" v-if="FieldTypeID!=10">
                        <el-input v-model="GroupHeader" type="textarea"></el-input>
                    </el-form-item>

                    <el-form-item label="Group Footer:" v-if="FieldTypeID!=10">
                        <el-input v-model="GroupFooter" type="textarea"></el-input>
                    </el-form-item>

                    <el-form-item label="Custom Text Pompt:" v-if="FieldTypeID==2||FieldTypeID==3||FieldTypeID==4 || FieldTypeID==9|| FieldTypeID==13">
                        <el-input v-model="CustomTextPompt"></el-input>
                    </el-form-item>

                    <el-form-item label="Select Others Value:" v-if="FieldTypeID==2||FieldTypeID==3||FieldTypeID==4 || FieldTypeID==9|| FieldTypeID==13">
                        <el-input v-model="ComboBoxOthersValue"></el-input>
                    </el-form-item>

                    <el-form-item label="Title Capital:" v-if="FieldTypeID==1">
                        <el-switch v-model="TitleCapital" ></el-switch>
                    </el-form-item>

                    <el-form-item label="Uppercase:" v-if="FieldTypeID==1">
                        <el-switch v-model="Uppercase" ></el-switch>
                    </el-form-item>

                    <el-form-item label="Options Layout:" v-if="FieldTypeID==2||FieldTypeID==3||FieldTypeID==4 || FieldTypeID==9|| FieldTypeID==13">
                        
                        <el-select v-model="Layout" placeholder="Select" clearable>
                            <el-option label="1" value="1" selected></el-option>
                            <el-option label="2" value="2"></el-option>
                            <el-option label="3" value="3"></el-option>
                            <el-option label="4" value="4"></el-option>
                        </el-select>
                        <div class="fieldItemNote">
                            one item one line by default
                        </div>
                    </el-form-item>

                    <el-form-item label="Hide Label:" v-if="FieldTypeID!=10">
                        <el-switch v-model="HideLabel" ></el-switch>
                    </el-form-item>

                    <el-form-item label="Default Value:" v-if="FieldTypeID!=10">
                        <el-input v-model="DefaultValue"></el-input>
                    </el-form-item>

                    
                    <el-form-item label="Display Same Line:" v-if="FieldTypeID!=10">
                    <!-- <el-select v-model="DisplaySameLineAfterPreFd" placeholder="Select" clearable>
                            <el-option v-for="(item, index) in list" :key="item.id" :label="item.FieldName" :disabled="item.id == id"
                                :value="item.id"></el-option>
                        </el-select> -->
                        
                        <el-switch v-model="DisplaySameLineAfterPreFd" ></el-switch>
                    </el-form-item>

                    <el-form-item label="Visible Depend Field:" v-if="FieldTypeID!=10">
                    <el-select v-model="VisibleDependFieldCode" placeholder="Select" clearable>
                            <el-option v-for="(item, index) in list" :key="item.id" :label="item.FieldName" :disabled="item.id == id"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Visible Depend Field Value:" v-if="VisibleDependFieldCode!=''">
                        <el-input v-model="VisibleDependFieldValue"></el-input>
                    </el-form-item>

                    <el-form-item label="Compulsory Depend Field:" v-if="FieldTypeID!=10">
                    <el-select v-model="CompulsoryDependFieldCode" placeholder="Select" clearable>
                            <el-option v-for="(item, index) in list" :key="item.id" :label="item.FieldName" :disabled="item.id == id"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Compulsory Depend Field Value:"  v-if="CompulsoryDependFieldCode!=''">
                        <el-input v-model="CompulsoryDependFieldValue"></el-input>
                    </el-form-item>


                    <el-form-item label="Compare Field:" v-if="FieldTypeID!=10">
                    <el-select v-model="CompareFieldCode" placeholder="Select" clearable>
                            <el-option v-for="(item, index) in list" :key="item.id" :label="item.FieldName" :disabled="item.id == id"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Compare Diff:" v-if="CompareFieldCode!=''">
                        <el-input v-model="CompareDiff"></el-input>
                    </el-form-item>
                    <el-form-item label="Compare Sign:"  v-if="CompareFieldCode!=''">
                        <el-select v-model="CompareSign" placeholder="Select" clearable>
                            <el-option label=">" value=">"></el-option>
                            <el-option label="<" value="<"></el-option>
                            <el-option label="=" value="="></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Compare Error Message:"  v-if="CompareFieldCode!=''">
                        <el-input v-model="CompareErrorMessage"></el-input>
                    </el-form-item>



                </el-form>
                <div slot="footer" class="dialog-footer" style="text-align: center;">
                    <el-button @click="dialogFormVisible = false">Cancel</el-button>
                    <el-button type="primary" @click="submit">OK</el-button>
                </div>
            </div>
            </el-dialog>


            <div style="height: 35px;"></div>
        </div>
        <!-- content -->

    </div>
</template>

<script>

import axios from 'axios'
import topmenu from '../home/components/topmenu'

export default {
    name: 'fieldlist',
    data: function () {
        return {
            id: 0,
            eventId: '',
            eventList: [],
            btnDis: false,
            radioStep: '1',
            nickname: '',
            loading: false,
            list: [""],
            total: 2,
            dialogFormVisible: false,
            form: [],
            Name: '',
            nameErr: '',
            badgeList: [],
            IsDefault: false,
            BadgeTemplate: '',
            StartTime: '',
            EndTime: '',

            currentPage: 1,

            FieldName:'',
            FieldCode:'',
            BackendFieldName:'',
            FieldDesc:'',
            PreDefinedFieldID:'',
            preFieldTypeList:[],
            FieldTypeID:'',
            FieldTypeErr:'',
            fieldTypeList:[],
            IsCompulsory:false,
            IsReadOnly:false,
            PhoneCodeModel:'1',
            LookupValues:'',
            LookupValuesArr:[],//[{txt:'a',edit:false},{'txt':'ab','edit':false},{txt:'ac',edit:false}],
            optionEditTxt:'',
            SortLookupValues:false,
            MaxLength:0,
            IsLimitedInList:false,
            Hint:'',
            Note:'',
            RequiredFieldValidatorErrorMessage:'',
            RegularExpressionValidatorValidationExpression:'',
            RegularExpressionValidatorErrorMessage:'',
            SelfRegSkip:false,
            IsEdmEmail:false,
            TextMode:'',
            IsAdminCompulsory:false,
            MinValue:'',
            MaxValue:'',
            StaticHtml:'',
            GroupHeader:'',
            GroupFooter:'',
            CustomTextPompt:'',
            ComboBoxOthersValue:'',
            TitleCapital:false,
            Uppercase:false,
            Layout:'',
            HideLabel:false,
            DefaultValue:'',
            DisplaySameLineAfterPreFd:false,
            DisplaySameLineAfterFieldName:'',
            VisibleDependFieldCode:'',
            VisibleDependFieldName:'',
            VisibleDependFieldValue:'',
            CompulsoryDependFieldCode:'',
            CompulsoryDependFieldName:'',
            CompulsoryDependFieldValue:'',
            CompareFieldCode:'',
            CompareFieldName:'',
            CompareDiff:'',
            CompareSign:'',
            CompareErrorMessage:'',
        }
    },
    components: {
        topmenu
    },
    methods: {
        upOption(index){
if(index>0){
    var arr = this.LookupValuesArr;

arr.splice(index-1,2,arr[index],arr[index-1]);
this.LookupValuesArr = arr;
}
        },
        downOption(index){
            var arr = this.LookupValuesArr;
if(index<arr.length-1){
    var arr = this.LookupValuesArr;

arr.splice(index,2,arr[index+1],arr[index]);
this.LookupValuesArr = arr;
}
        },
        editOption(index){
            var arr = this.LookupValuesArr;
            
            var item = arr[index];
var arr2=[];
            if(item.edit==true){
                
            }else{
for(var i=0;i<arr.length;i++){
    if(i==index){
    arr2.push({txt:arr[i].txt,edit:true});
    this.optionEditTxt = arr[i].txt;
    }else{
    arr2.push({txt:arr[i].txt,edit:false});
    }
}
this.LookupValuesArr = arr2;
            }
        },
        editOptionBlur(index){
            var arr = this.LookupValuesArr;
            
            var item = arr[index];
var arr2=[];
            if(item.edit==true){
                for(var i=0;i<arr.length;i++){
                    if(i==index){
    arr2.push({txt:this.optionEditTxt,edit:false});
    }else{
    arr2.push({txt:arr[i].txt,edit:false});
    }
}
this.optionEditTxt='';
            }else{
for(var i=0;i<arr.length;i++){
    if(i==index){
    arr2.push({txt:arr[i].txt,edit:true});
    this.optionEditTxt = arr[i].txt;
    }else{
    arr2.push({txt:arr[i].txt,edit:false});
    }
}
            }
this.LookupValuesArr = arr2;
        },
        delOption(index){
console.log(index);
var arr = this.LookupValuesArr;
arr.splice(index,1);
this.LookupValuesArr=arr;
        },
        addOption(){
var arr = this.LookupValuesArr;
var arr2=[];
for(var i=0;i<arr.length;i++){
    arr2.push({txt:arr[i].txt,edit:false});
}
arr2.push({txt:'',edit:true});
this.LookupValuesArr = arr2;
        },
        preDefinedFieldChange(val){
            console.log(val);
            var typeid = '';
            for(var i=0;i<this.preFieldTypeList.length;i++){
                if(this.preFieldTypeList[i].id==val)
                {
                    typeid = this.preFieldTypeList[i].fieldTypeId;
                }
            }
            this.FieldTypeID = typeid;
        },
        add() {
            this.dialogFormVisible = true;
            this.id = '';
            
            
            this.FieldName='';
            this.FieldCode='';
            this.BackendFieldName='';
            this.FieldDesc='';
            this.PreDefinedFieldID='';
            // this.preFieldTypeList=[];
            this.FieldTypeID='';
            this.FieldTypeErr='';
            // this.fieldTypeList=[];
            this.IsCompulsory=false;
            this.IsReadOnly=false;
            this.LookupValues='';
            this.LookupValuesArr=[];//[{txt='a';edit=false};{'txt'='ab';'edit'=false};{txt='ac';edit=false}];
            this.optionEditTxt='';
            this.SortLookupValues=false;
            this.PhoneCodeModel = '1';
            this.MaxLength=0;
            this.IsLimitedInList=false;
            this.Hint='';
            this.Note='';
            this.RequiredFieldValidatorErrorMessage='';
            this.RegularExpressionValidatorValidationExpression='';
            this.RegularExpressionValidatorErrorMessage='';
            this.SelfRegSkip=false;
            this.IsEdmEmail=false;
            this.TextMode='';
            this.IsAdminCompulsory=false;
            this.MinValue='';
            this.MaxValue='';
            this.StaticHtml='';
            this.GroupHeader='';
            this.GroupFooter='';
            this.CustomTextPompt='';
            this.ComboBoxOthersValue='';
            this.TitleCapital=false;
            this.Uppercase=false;
            this.Layout='';
            this.HideLabel=false;
            this.DefaultValue='';
            this.DisplaySameLineAfterPreFd=false;
            this.DisplaySameLineAfterFieldName='';
            this.VisibleDependFieldCode='';
            this.VisibleDependFieldName='';
            this.VisibleDependFieldValue='';
            this.CompulsoryDependFieldCode='';
            this.CompulsoryDependFieldName='';
            this.CompulsoryDependFieldValue='';
            this.CompareFieldCode='';
            this.CompareFieldName='';
            this.CompareDiff='';
            this.CompareSign='';
            this.CompareErrorMessage='';
        },
        goBack() {
            this.$router.back();
        },
        submit() {
            if (this.FieldName == '') {
                this.nameErr = "required";
                return;
            } else {
                this.nameErr = "";
            }
            if (this.FieldTypeID == '') {
                this.FieldTypeErr = "required";
                return;
            } else {
                this.FieldTypeErr = "";
            }
            if (this.eventId == '' || this.eventId == 0) {
                this.$message.error('Please select Event');
                return;
            }
            this.onSubmit();
        },
        nameChange(val) {
            console.log(val);
            if (val != '' && val.length > 0) { this.nameErr = ''; }
            else {
                this.nameErr = "required";
            }
        },
        onSubmit() {
            this.loading = true;
            this.btnDis = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));

            var uid = userJson.uid;
            var token = userJson.token;
            var LookupValuesArr = this.LookupValuesArr;
var LookupValuesArr2 = [];
for(var i=0;i<LookupValuesArr.length;i++){
    LookupValuesArr2.push(LookupValuesArr[i].txt);
}
var LookupValues = LookupValuesArr2.join('|');
            axios.post('/api/Fields/editInfo',
                {
                    uid: uid,
                    token: token,
                    id: this.id,
                    eventid: this.eventId,
                    
                    FieldName:this.FieldName,
            FieldCode:this.FieldCode,
            BackendFieldName:this.BackendFieldName,
            FieldDesc:this.FieldDesc,
            PreDefinedFieldID:this.PreDefinedFieldID,
            preFieldTypeList:this.preFieldTypeList,
            FieldTypeID:this.FieldTypeID,
            FieldTypeErr:this.FieldTypeErr,
            fieldTypeList:this.fieldTypeList,
            IsCompulsory:this.IsCompulsory,
            IsReadOnly:this.IsReadOnly,
            LookupValues:LookupValues,
            LookupValuesArr:this.LookupValuesArr,//[{txt:'a',edit:false},{'txt':'ab','edit':false},{txt:'ac',edit:false}],
            optionEditTxt:this.optionEditTxt,
            SortLookupValues:this.SortLookupValues,
            PhoneCodeModel:this.PhoneCodeModel,
            MaxLength:this.MaxLength,
            IsLimitedInList:this.IsLimitedInList,
            Hint:this.Hint,
            Note:this.Note,
            RequiredFieldValidatorErrorMessage:this.RequiredFieldValidatorErrorMessage,
            RegularExpressionValidatorValidationExpression:this.RegularExpressionValidatorValidationExpression,
            RegularExpressionValidatorErrorMessage:this.RegularExpressionValidatorErrorMessage,
            SelfRegSkip:this.SelfRegSkip,
            IsEdmEmail:this.IsEdmEmail,
            TextMode:this.TextMode,
            IsAdminCompulsory:this.IsAdminCompulsory,
            MinValue:this.MinValue,
            MaxValue:this.MaxValue,
            StaticHtml:this.StaticHtml,
            GroupHeader:this.GroupHeader,
            GroupFooter:this.GroupFooter,
            CustomTextPompt:this.CustomTextPompt,
            ComboBoxOthersValue:this.ComboBoxOthersValue,
            TitleCapital:this.TitleCapital,
            Uppercase:this.Uppercase,
            Layout:this.Layout,
            HideLabel:this.HideLabel,
            DefaultValue:this.DefaultValue,
            DisplaySameLineAfterPreFd:this.DisplaySameLineAfterPreFd,
            DisplaySameLineAfterFieldName:this.DisplaySameLineAfterFieldName,
            VisibleDependFieldCode:this.VisibleDependFieldCode,
            VisibleDependFieldName:this.VisibleDependFieldName,
            VisibleDependFieldValue:this.VisibleDependFieldValue,
            CompulsoryDependFieldCode:this.CompulsoryDependFieldCode,
            CompulsoryDependFieldName:this.CompulsoryDependFieldName,
            CompulsoryDependFieldValue:this.CompulsoryDependFieldValue,
            CompareFieldCode:this.CompareFieldCode,
            CompareFieldName:this.CompareFieldName,
            CompareDiff:this.CompareDiff,
            CompareSign:this.CompareSign,
            CompareErrorMessage:this.CompareErrorMessage,
                }
            )
                .then(this.submitSucc)
        },
        submitSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.$message({
                    message: 'Success!',
                    type: 'success',
                    onClose: () => {
                    }
                });
                this.dialogFormVisible = false;
                this.loadData();
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

        stepChange(step) {
            console.log(step);
        },
        loadData() {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Fields/getFieldsList',
                {
                    eventId: this.eventId,
                    usertype: 100,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadDataSucc)
        },
        loadDataSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                
                this.total = res.total;
                this.list = res.list;
                this.$refs.table.doLayout();
                
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

        loadEvent() {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/event/getList',
                {
                    limit: 10000,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadEventSucc)
        },
        loadEventSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                if (res.list && res.list.length > 0) {
                    this.eventList = res.list;
                    console.log(this.eventList);
                    if (this.eventId == '' || this.eventId == 0) {
                        this.eventId = res.list[0].id;
                    }
                        this.loadData();
                }
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

        loadFieldType() {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Fields/getPreDefinedFieldIDList',
                {
                    limit: 10000,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadFieldTypeSucc)
        },
        loadFieldTypeSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                if (res.list1) {
                    this.fieldTypeList = res.list1;
                }
                if (res.list2) {
                    var list2 = res.list2;
                    // list2.unshift({id:'',fieldName:''});
                    this.preFieldTypeList = list2;
                    console.log(this.preFieldTypeList);
                }
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

        handleCommand(command) {
            if (command == 'logout') {
                localStorage.removeItem('userJson');
                this.$router.replace('/login');
            }
        },

        eventChange(id) {
            console.log(id);
            localStorage.setItem('eventId',id);
            this.currentPage = 1;
            this.loadData();
        },

        toeventlist() {
            this.$router.replace('/eventlist');
        },
        handleCurrentChange(page) {
            console.log(page)
            this.loadData();
        },
        handleDelete(index, row) {
            console.log(index, row);
            var id = row.id;
            console.log(id);

            this.$confirm('This will permanently delete the data. Continue?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.delCate(id);
            });

        },
        handleFieldUp(index,row){
            if(index<1)
            {return;}
            var id = row.id;
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Fields/editFieldOrdinal',
                {
                    id: id,
                    type:-1,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.handleFieldDownSucc)
        },
        handleFieldDown(index,row){
            if(index>=(this.list.length-1)){
                return;
            }
            var id = row.id;
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Fields/editFieldOrdinal',
                {
                    id: id,
                    type:1,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.handleFieldDownSucc)
        },
        handleFieldDownSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.loadData();
                
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },
        handleEdit(index, row) {
            console.log(index, row);
            var id = row.id;
            console.log(id);
            this.id = id;
            this.FieldName = row.FieldName;
            this.FieldCode = row.FieldCode;
            this.BackendFieldName = row.BackendFieldName;
            this.FieldDesc = row.FieldDesc;
            this.PreDefinedFieldID = row.PreDefinedFieldID==null?'':row.PreDefinedFieldID;
            // this.preFieldTypeList = row.preFieldTypeList;
            this.FieldTypeID = row.FieldTypeID;
            this.FieldTypeErr = row.FieldTypeErr;
            // this.fieldTypeList = row.fieldTypeList;
            this.IsCompulsory = row.IsCompulsoryStr.toLowerCase() === "true";
            this.IsReadOnly = row.IsReadOnlyStr.toLowerCase() === "true";
            this.LookupValues = row.LookupValues;
            var LookupValuesArr = [];
            if(row.LookupValues!=''){
                console.log(row.LookupValues);
                var lvArr = row.LookupValues.split("|");
            for(var i=0;i<lvArr.length;i++){
                LookupValuesArr.push({txt:lvArr[i]});
            }
            }
            this.LookupValuesArr = LookupValuesArr;
            this.optionEditTxt = row.optionEditTxt;
            this.SortLookupValues = row.SortLookupValues;
            this.PhoneCodeModel = row.PhoneCodeModelStr==null? '1':row.PhoneCodeModelStr.toLowerCase() == "select"?'1':'2';
            this.MaxLength = row.MaxLength;
            this.IsLimitedInList = row.IsLimitedInListStr.toLowerCase() === "true";
            this.Hint = row.Hint;
            this.Note = row.Note;
            this.RequiredFieldValidatorErrorMessage = row.RequiredFieldValidatorErrorMessage;
            this.RegularExpressionValidatorValidationExpression = row.RegularExpressionValidatorValidationExpression;
            this.RegularExpressionValidatorErrorMessage = row.RegularExpressionValidatorErrorMessage;
            this.SelfRegSkip = row.SelfRegSkipStr.toLowerCase() === "true";
            this.IsEdmEmail = row.IsEdmEmailStr.toLowerCase() === "true";
            this.TextMode = row.TextMode;
            this.IsAdminCompulsory = row.IsAdminCompulsoryStr.toLowerCase() === "true";
            this.MinValue = row.MinValue;
            this.MaxValue = row.MaxValue;
            this.StaticHtml = row.StaticHtml;
            this.GroupHeader = row.GroupHeader;
            this.GroupFooter = row.GroupFooter;
            this.CustomTextPompt = row.CustomTextPompt;
            this.ComboBoxOthersValue = row.ComboBoxOthersValue;
            this.TitleCapital = row.TitleCapitalStr.toLowerCase() === "true";
            this.Uppercase = row.UppercaseStr.toLowerCase() === "true";
            this.Layout = row.Layout;
            this.HideLabel = row.HideLabelStr.toLowerCase() === "true";
            this.DefaultValue = row.DefaultValue;
            this.DisplaySameLineAfterPreFd = row.DisplaySameLineAfterPreFd;
            this.DisplaySameLineAfterFieldName = row.DisplaySameLineAfterFieldName;
            this.VisibleDependFieldCode = row.VisibleDependFieldCode;
            this.VisibleDependFieldName = row.VisibleDependFieldName;
            this.VisibleDependFieldValue = row.VisibleDependFieldValue;
            this.CompulsoryDependFieldCode = row.CompulsoryDependFieldCode;
            this.CompulsoryDependFieldName = row.CompulsoryDependFieldName;
            this.CompulsoryDependFieldValue = row.CompulsoryDependFieldValue;
            this.CompareFieldCode = row.CompareFieldCode;
            this.CompareFieldName = row.CompareFieldName;
            this.CompareDiff = row.CompareDiff;
            this.CompareSign = row.CompareSign;
            this.CompareErrorMessage = row.CompareErrorMessage;
            
            
            this.dialogFormVisible = true;
        },
        delCate(id) {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Fields/deleteField',
                {
                    id: id,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.delCateSucc)
        },
        delCateSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.loadData();
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

    },
    mounted() {
        const id = this.$route.query.id;
        console.log(id)
        if (id != undefined && id != '') {

        }

        var eventId = localStorage.getItem('eventId');
        if(eventId!=null && eventId!=undefined){
            eventId = parseInt(eventId);
            this.eventId=eventId;
        }

        // this.loadData();
        this.loadEvent();
        this.loadFieldType();
        var userJson = JSON.parse(localStorage.getItem("userJson"));
        console.log(userJson);
        var nickname = userJson['nickname'];
        this.nickname = nickname;
        console.log(this.nickname);
    },
    beforeDestroy() {

    }
}
</script>
<style scoped>
.container2 /deep/ .cell{
    max-height: 115px;
}
.optionItem{
    display: flex;
    border:1px #409EFF solid;
    padding: 0 0 0 12px;
    margin-bottom: 16px;
    flex: 1;
    margin-left: 16px;
}
.optionItemTxt{
    flex: 1;
}
.optionItemTop{
    border-left: 1px #409EFF solid;
    border-right: 1px #409EFF solid;
    padding: 0 13px;
    cursor: pointer;
    color: #67C23A;
}
.optionItemBtm{
    border-right: 1px #409EFF solid;
    padding: 0 13px;
    cursor: pointer;
    color: #67C23A;
}
.optionItemDel{

    padding: 0 13px;
    cursor: pointer;
    color: #F56C6C;
}
.optionItemEdit{

    border-right: 1px #409EFF solid;
    padding: 0 13px;
    cursor: pointer;
    color: #409EFF;
}
.optionItemControl:hover{
    background: rgb(233, 233, 235);
}

.container2{
    margin:0 12px;
}
.container2 >>> .fieldEditDialog{
    margin-top: 100px !important;
}

.fieldItemNote{
    font-size: 14px;
    color:grey;
    font-style: italic;
    line-height: 20px;
}

.root >>> .topmenuitem:nth-child(5){
    color: #fff;
 background-color: #080808;
}
</style>



// WEBPACK FOOTER //
// src/pages/fields/fieldlist.vue